<template>
  <div class="row d-flex justify-content-center">
    <div class="col-12">
      <table class="table">
        <tbody>
          <tr class="shadow-sm" v-for="(info, index) in rows" :key="index">
            <td-info-tag
              v-if="showInfoTag(info)"
              :data="info.value"
              :tdLabel="`${info.label}: `"
              :fieldTag="info.fieldTag"
              effect="dark"
            />
            <template v-else-if="info.type === 'activities'">
              <info-activities :activities="infoData.name" :model="infoData" />
            </template>
            <td
              :style="{
                wordBreak: 'auto-phrase',
                textAlign: 'justify',
              }"
              v-else-if="
                typeof info.visibility === 'undefined' ||
                Boolean(info.visibility)
              "
            >
              <h6 class="mb-1">
                <strong>{{ info.label }}:</strong>
              </h6>
              <span v-if="validateIsset(info.value)" class="mt-2">
                {{ info.value }}
              </span>
              <el-tag v-else type="warning" effect="dark" class="mt-2">{{
                $t('common_words.no_assignment')
              }}</el-tag>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { isset } from 'src/util/Util.js';
import i18n from 'src/i18n';
import InfoActivities from './InfoActivities.vue';
import TdInfoTag from 'src/components/Tables/TdInfoTag.vue';

export default {
  name: 'step-confirm',
  components: {
    [InfoActivities.name]: InfoActivities,
    [TdInfoTag.name]: TdInfoTag,
  },
  props: {
    infoData: {
      typeof: Object,
      required: true,
    },
  },
  computed: {
    rows() {
      return [
        {
          label: i18n.t('common_words.code'),
          value: this.infoData.group_code,
        },
        {
          label: i18n.t('common_words.group'),
          value: this.infoData.group_name,
        },
        {
          label: i18n.t('common_words.companies2'),
          value: this.infoData.businesses_names,
          fieldTag: 'option',
        },
        {
          label: i18n.t('common_words.associated_profiles2'),
          value: this.infoData.roles_name,
          fieldTag: 'option',
        },
        {
          label: i18n.t('common_words.associated_users2'),
          value: this.infoData.users_name,
          fieldTag: 'option',
        },
        {
          label: i18n.t('common_words.activities'),
          value: this.infoData.name,
          type: 'activities',
        },
      ];
    },
  },
  methods: {
    validateIsset(data) {
      return isset(data);
    },
    showInfoTag(info) {
      return (
        (typeof info.visibility === 'undefined' || Boolean(info.visibility)) &&
        this.validateIsset(info.value) &&
        Array.isArray(info.value) &&
        info.type !== 'activities'
      );
    },
  },
};
</script>
